'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.text = exports.rect = exports.round = exports.textRow = exports.MediaBlock = exports.TextBlock = exports.RectShape = exports.RoundShape = exports.TextRow = undefined;

var _TextRow2 = require('./TextRow');

var _TextRow3 = _interopRequireDefault(_TextRow2);

var _RoundShape2 = require('./RoundShape');

var _RoundShape3 = _interopRequireDefault(_RoundShape2);

var _RectShape2 = require('./RectShape');

var _RectShape3 = _interopRequireDefault(_RectShape2);

var _TextBlock2 = require('./TextBlock');

var _TextBlock3 = _interopRequireDefault(_TextBlock2);

var _MediaBlock2 = require('./MediaBlock');

var _MediaBlock3 = _interopRequireDefault(_MediaBlock2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TextRow = _TextRow3.default;
// import Card from 'Card';

exports.RoundShape = _RoundShape3.default;
exports.RectShape = _RectShape3.default;
exports.TextBlock = _TextBlock3.default;
exports.MediaBlock = _MediaBlock3.default;
var textRow = exports.textRow = _TextRow3.default;
var round = exports.round = _RoundShape3.default;
var rect = exports.rect = _RectShape3.default;
var text = exports.text = _TextBlock3.default;
var media = exports.media = _MediaBlock3.default;


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-placeholder/lib/placeholders/index.js
 ** module id = 1938
 ** module chunks = 3
 **/